import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowBottom2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="Group">
          <path
            id="Vector"
            d="M5.98617 8C5.65517 8.0005 5.34017 7.85879 5.12167 7.61079L0.216167 2.04614C-0.111833 1.65644 -0.0608328 1.07512 0.330167 0.747792C0.708167 0.431437 1.26867 0.467364 1.60267 0.829126L5.89217 5.6952C5.93767 5.74709 6.01667 5.75208 6.06867 5.70668C6.07267 5.70318 6.07667 5.69919 6.08017 5.6952L10.3697 0.829126C10.6977 0.439421 11.2802 0.388524 11.6707 0.715357C12.0612 1.04269 12.1122 1.624 11.7847 2.01371C11.7757 2.02469 11.7662 2.03517 11.7562 2.04614L6.85217 7.6088C6.63317 7.85729 6.31767 7.9995 5.98617 8Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
